import { render, staticRenderFns } from "./ApprovalLevel.vue?vue&type=template&id=ad519078&scoped=true&"
import script from "./ApprovalLevel.vue?vue&type=script&lang=js&"
export * from "./ApprovalLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad519078",
  null
  
)

export default component.exports